export default function AccessDenied() {
  return (
    <div className="h-screen bg-primary with-splash-bg flex items-center justify-between">
      <h1 className="text-white text-center font-bold text-4xl w-full">
        <span className="rounded bg-black/20 p-4">Access Denied</span>
      </h1>
    </div>
  );
}
